<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    newsVideos: {
        type: Array,
        required: true
    }
})
</script>

<template>
    <div class="news-videos">
        <iframe
            v-for="(videoLink, index) in props.newsVideos"
            :key="index"
            class="video-iframe ml-auto mr-auto"
            :src="videoLink"
        />
    </div>
</template>

<style scoped lang="scss"></style>
